import { Box } from 'ui/components/Box'
import { makeComponent } from 'ui/helpers/recipes'

import { CalendarHeaderStyles, DayInnerStyles, DayWrapperStyles } from './DatePicker.css'

export const DayWrapper = makeComponent('div', DayWrapperStyles)
export const DayInner = makeComponent('div', DayInnerStyles)
export const CalendarHeader = makeComponent(Box, CalendarHeaderStyles)
